/* eslint-disable @typescript-eslint/no-use-before-define */
import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { getCardInfo } from 'redux/accountInfo/accountInfoSlice'
import invoiceNetTermsAPI from 'services/invoiceNetTerms'
import { INTRequest, INTResponse } from 'typings/invoiceNetTerms'
import { NetTermsState } from 'typings/reduxStore'
import { ServerError } from 'typings/serverError'

export const initState: NetTermsState = {
  error: false,
  errorMessage: '',
  isEnrollmentSuccess: false,
  isUnEnrollmentSuccess: false,
  invoiceNetTermsInfo: {} as INTResponse,
  isEmailUpdated: false
}

export const getINTState = createAsyncThunk(
  'invoiceNetTermsSlice/getINTState',
  async (payload: INTRequest, { dispatch }) => {
    try {
      const response = await invoiceNetTermsAPI.getInvoiceNetTerms(payload)

      const { enrollmentStatus, invoiceNetTermsInfo, accessToken } = payload

      const accountNumber = invoiceNetTermsInfo?.['cipher.accountId'] || ''

      const updateInfo: NetTermsState = {
        error: false,
        errorMessage: '',
        isEnrollmentSuccess: enrollmentStatus === 'Enroll',
        isUnEnrollmentSuccess: enrollmentStatus === 'UnEnroll',
        isEmailUpdated: enrollmentStatus === 'updateEmail'
      }

      if (enrollmentStatus !== 'updateEmail') {
        updateInfo.invoiceNetTermsInfo = response
      }

      dispatch(getCardInfo({ accountNumber, accessToken }))

      dispatch(
        updateINTState({
          ...updateInfo
        })
      )
    } catch (errorResponse) {
      const { response } = errorResponse as ServerError
      const { message } = response

      dispatch(
        updateINTState({
          error: true,
          errorMessage: message
        })
      )
    }
  }
)

const invoiceNetTermsSlice = createSlice({
  name: 'invoiceNetTermsSlice',
  initialState: initState,
  reducers: {
    updateINTState: (
      state: NetTermsState,
      action: PayloadAction<NetTermsState>
    ) => {
      return {
        ...state,
        ...action.payload
      }
    }
  }
})

export const { updateINTState } = invoiceNetTermsSlice.actions

export default invoiceNetTermsSlice.reducer
